// extracted by mini-css-extract-plugin
export default {"button":"AddButton_button__rn9Q1","iconWrapper":"AddButton_iconWrapper__yrUEe","text":"AddButton_text__hI7CS"};